<template>
  <div class="treeNoChoose">
    <!-- <div class="inputSearch" style="margin: 10px 0" v-if="dataTree.searchShow">
      <el-input
        placeholder=""
        suffix-icon="el-icon-search"
        v-model="filterText">
      </el-input>
    </div> -->

    <div class="selectSpot2" style="height: 615px;overflow: auto;width: 500px">
      <el-tree
        v-if="isRouterAlive"
        :expand-on-click-node="false"
        :data="treeListData"
        :props="defaultProps"
        accordion
        :load="loadNode"
        lazy
        node-key="id"
        :default-expanded-keys="defaultKeys"
        :current-node-key="currentKey"
        highlight-current
        ref="tree"
        @node-click="handleNodeClickDevice">
        <div class="custom-tree-node" slot-scope="{node,data}" @click="open(data)">
          <div class="title" style="display: flex">
            <p>
              <template v-if="dataTree.cardShow">
                <i class="el-icon-s-management" @click="showCard(data.id)" v-if="data.type=='1'"></i>
              </template>
            </p>
            <el-tooltip class="item" effect="dark" :content="data.name" placement="bottom-start"
                        v-if="data.name.length>8">
              <p
                style="width: 100%;overflow: hidden;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;">
                {{ data.name }}</p>
            </el-tooltip>
            <p
              style="width: 100%;overflow: hidden;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;"
              v-if="data.name.length<=8">{{ data.name }}</p>
          </div>
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
import file from "@/assets/js/common/common.js";
import file1 from "@/assets/js/file/file.js";
import organizationTabJs from "@/assets/js/system/organizationTab.js";
import checkItem from "@/components/list/displayPage/checkItemParam";
import maintenanceItem from "@/components/list/displayPage/maintenanceItemParam";
import inspectionItem from "@/components/list/displayPage/inspectionItemParam";
import electronDocument from "@/components/list/displayPage/electronDocumentParam";
import partInfo from "@/components/list/displayPage/partInfoParam";
import position from "@/components/list/displayPage/positionParam";
import utils from '@/utils/utils'

export default {
  name: "tree",
  components: {
    checkItem,
    maintenanceItem,
    inspectionItem,
    electronDocument,
    partInfo,
    position
  },
  props: {
    treeType: {
      type: Number,
      default: 0
    },
    dataTree: {
      type: Object,
      default: {}
    },
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      restaurants: [],
      name: '',
      timeout: null,
      defaultKeys: ['0'],
      currentKey: '',
      pageNum: 1,
      pageSize: 10,
      pageCount: 0,
      filterText: '',
      Readytime: '',
      editEqumentName: this.$t('label_466'),
      drawer: false,
      drawerTab: false,
      isRouterAlive: true,
      newType: {
        name: '',
        operationState: '1',
        failureState: '1',
        lifeState: '1',
        pid: '0'
      },
      copyType: {
        id: '',
        num: '',
        pid: '0',
        name: ''
      },
      dialogEquDeviceAdd: false,
      dialogEquDeviceCopy: false,
      activeNameSpot: 'spot',
      searchDataList: {
        equipmentId: '',
        versionFlag: 0,
        deviceId: ''
      },
      tableDeviceLvli: [{
        type: '点检',
        time: '2021/01/01 08:00-08:20',
        user: '张三',
        status: '已检'
      }, {
        type: '点检',
        time: '2021/01/01 08:00-08:20',
        user: '张三',
        status: '已检'
      }, {
        type: '点检',
        time: '2021/01/01 08:00-08:20',
        user: '张三',
        status: '已检'
      }, {
        type: '点检',
        time: '2021/01/01 08:00-08:20',
        user: '张三',
        status: '已检'
      }],
      tableDataTree: [],
      tableDataTxt: [],
      cardData: [],
      parameterData: [],
      checkInfoData: [],
      maintainInfoData: [],
      inspectionInfoData: [],
      documentInfoData: [],
      partInfoData: [],
      openData: [],
      checked: false,
      treeListData: [{
        name: this.$t('label_272'),
        id: '0',
        children: [{}]
      }],
      treeListDataCopy: [{
        name: this.$t('label_272'),
        id: 0,
        children: [{}]
      }],
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: function (data) {
          if (data.type == '1') {
            return true
          } else {
            return false
          }
        }
      },
    }
  },
  watch: {
    // filterText(val) {
    // 	this.$refs.tree.filter(val);
    // }
  },
  methods: {
    clearSearch() {
      this.$refs.myAutocomplete.handleFocus()
    },
    querySearchAsync(queryString, cb) {
      let param = {}
      if (queryString == undefined) {
        param = {name: ''}
      } else {
        param = {name: queryString}
      }
      //类型 0：类型 1：区域
      if (this.treeType == 0) {
        file1.selectTypeListByName2(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            cb(data.data)
          }
        }).catch((response) => {
          console.log(response)
        })
      } else {
        file1.selectDeptListByName2(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            cb(data.data)
          }
        }).catch((response) => {
          console.log(response)
        })
      }

    },
    handleSelect(item) {
      if (item.type == 1) {
        this.expandEq(item.id, item.pid, this.treeType);
      } else {
        this.expand(item.id, this.treeType);
      }
    },
    expandEq(eqId, id, type) {
      file1.findPids({id: id, type: type}).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          let keys = data.data;
          keys.push(eqId);
          this.defaultKeys = keys;
          setTimeout(() => {
            this.$refs.tree.setCurrentKey(eqId);
            let node0 = this.$refs.tree.getCurrentNode();
            this.$emit('getDeviceMes', node0);
          }, 500)
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    expand(id, type) {
      file1.findPids({id: id, type: type}).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.defaultKeys = data.data;
          setTimeout(() => {
            this.$refs.tree.setCurrentKey(id);
            let node0 = this.$refs.tree.getCurrentNode();
            this.open(node0);
          }, 500)
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    dbSelected(id, eqId) {
      file1.findPids({id: id, type: this.treeType}).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.defaultKeys = data.data;
          setTimeout(() => {
            if (eqId != null) {
              this.$refs.tree.setCurrentKey(eqId);
            } else {
              this.$refs.tree.setCurrentKey(id);
            }
            let node0 = this.$refs.tree.getCurrentNode();
            this.open(node0);
          }, 500)
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    upload(file1) {
      var formData = new FormData();
      formData.append('file', file1.file);
      file.upload(formData).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.cardData.img = data.data
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    addEquipmentType(id) {
      this.dialogEquDeviceAdd = true;
      if (this.dataTree.funtoGetMes == '1') {
        this.editEqumentName = this.$t('label_466');
      } else {
        this.editEqumentName = this.$t('label_460');
      }
      this.newType.pid = id;
      this.newType.equipmentTypeId = id;
    },
    editClick(name, id, pid) {
      if (this.dataTree.funtoGetMes == '1') {
        this.editEqumentName = this.$t('label_485');
      } else {
        this.editEqumentName = this.$t('label_482');
      }
      this.newType.name = name;
      this.newType.id = id;
      this.newType.pid = pid;
      this.dialogEquDeviceAdd = true;
    },
    delEquipmentType(id) {
      let param = {
        id: id
      };
      let that = this;
      this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
        confirmButtonText: this.$t('label_100'),
        cancelButtonText: this.$t('btn_1'),
        type: 'warning'
      }).then(() => {
        if (this.dataTree.funtoGetMes == '1') {
          file.delEquipmentType(param).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              that.reload();
              this.$message({
                message: this.$t('msg_23'),
                type: 'success'
              });
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        }
        if (this.dataTree.funtoGetMes == '2') {
          file.delEquipmentInfo(param).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              that.reload();
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        }
      }).catch(() => {

      });
    },
    copyClick(id, name) {
      this.copyType.pid = id;
      this.copyType.name = name;
      this.dialogEquDeviceCopy = true;
    },
    checkFn(node, data) {
      let checkedKeys = data.checkedKeys;
      let currKey = node.id;
      this.copyType.pid = node.id;
      // this.$refs.tree2.setCheckedKeys([currKey]);
    },
    newTypeSave() {
      if (this.newType.name == "") {
        utils.messageAlert(this.$t('msg_30'), this.$t('label_358'), this.$t('label_100'));
        return
      }
      if (this.editEqumentName == this.$t('label_466') || this.editEqumentName == this.$t('label_460')) {
        if (this.dataTree.funtoGetMes == '1') {
          file.addEquipmentType(this.newType).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.$message({
                message: this.$t('msg_23'),
                type: 'success'
              });
              this.reload();
              this.dialogEquDeviceAdd = false;
              this.newType = {
                name: '',
                pid: '0'
              };
            } else {
              this.$message({
                message: this.$t('msg_143'),
                type: 'success'
              });
            }
          }).catch((response) => {
            console.log(response)
          })
        }
        if (this.dataTree.funtoGetMes == '2') {
          file.addEquipmentInfo(this.newType).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.$message({
                message: this.$t('msg_23'),
                type: 'success'
              });
              this.reload();
              this.dialogEquDeviceAdd = false;
              this.newType = {
                name: '',
                pid: '0'
              };
            }
          }).catch((response) => {
            console.log(response)
          })
        }
      } else {
        if (this.dataTree.funtoGetMes == '1') {
          file.editEquipmentType(this.newType).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.$message({
                message: this.$t('msg_23'),
                type: 'success'
              });
              this.reload();
              this.dialogEquDeviceAdd = false;
              this.newType = {
                name: '',
                pid: '0'
              };
            }
          }).catch((response) => {
            console.log(response)
          })
        }
        if (this.dataTree.funtoGetMes == '2') {
          file.editEquipmentInfo(this.newType).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.$message({
                message: this.$t('msg_23'),
                type: 'success'
              });
              this.reload();
              this.dialogEquDeviceAdd = false;
              this.newType = {
                name: '',
                pid: '0'
              };
            }
          }).catch((response) => {
            console.log(response)
          })
        }
      }
    },
    copyTypeSave() {
      if (this.copyType.pid == "") {
        utils.messageAlert(this.$t('input_48'), this.$t('label_358'), this.$t('label_100'));
        return
      }
      if (this.copyType.num == "") {
        utils.messageAlert(this.$t('input_47'), this.$t('label_358'), this.$t('label_100'));
        return
      }
      if (this.dataTree.funtoGetMes == '1') {
        file.copyEquipmentType(this.copyType).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.reload();
            this.dialogEquDeviceCopy = false;
            // this.$refs.tree2.setCheckedKeys([]);
            this.copyType = {
              id: '',
              name: '',
              pid: ''
            };
            this.$message({
              message: this.$t('msg_23'),
              type: 'success'
            });
          } else {
            utils.messageAlert(this.$t('msg_144'), this.$t('label_358'), this.$t('label_100'));
          }
        }).catch((response) => {
          console.log(response)
        })
      }
      if (this.dataTree.funtoGetMes == '2') {
        file.copyEquipment(this.copyType).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.reload();
            this.dialogEquDeviceCopy = false;
            // this.$refs.tree2.setCheckedKeys([]);
            this.copyType = {
              id: '',
              name: '',
              pid: ''
            };
          } else {
            utils.messageAlert(this.$t('msg_148'), this.$t('label_358'), this.$t('label_100'));
          }
        }).catch((response) => {
          console.log(response)
        })
      }
    },
    handleClose() {
      // if (this.dialogEquDeviceCopy) {
      //   this.$refs.tree2.setCheckedKeys([]);
      // }
      this.dialogEquDeviceAdd = false;
      this.dialogEquDeviceCopy = false;
      this.newType = {
        name: '',
        pid: '0'
      };
      this.copyType = {
        id: '',
        name: '',
        pid: ''
      };
    },
    handleClickSpot(tab, event) {
      if (tab.label == this.$t('label_335')) {
        this.heightNum = '360';
      } else {
        this.heightNum = '170';
      }
    },
    loadNode(node, resolve) {
      let that = this;
      if (!this.dataTree.dataAll) {
        if (node.level === 0) {
          let child = [];
          child = this.getEquipmentInfoList(0)
          child.then((res) => {
            this.$emit('getDeviceMes', res[0]);
            resolve(res);
          })
        } else {
          let child = [];
          child = this.getEquipmentInfoList(node.data.id);
          child.then((res) => {
            if (res == "") {
              return resolve([]);
            } else {
              resolve(res);
            }
          })
        }
      }
    },
    handleNodeClickDevice(data, checked, resolve) {
      this.copyType.id = data.id;
      this.openData = data;
      if (data.type != 1) {
        this.$emit('getDeviceMes', data);
      }

    },
    handleNodeClickDeviceCopy(data, checked, resolve) {

    },
    open(data) {
      this.$emit('getDeviceMes', data);
    },
    showCard(id) {
      this.drawer = true;
      this.drawerTab = true;
      this.selectCard(id);
      this.getEquipmentParameter(id);
      let param = {
        pageNum: 1,
        pageSize: 10,
      }
      this.searchDataList.equipmentId = id;
      this.searchDataList.deviceId = id;
      var newParam = Object.assign(param, this.searchDataList);
      this.$nextTick(() => {
        this.$refs.checkItemDisplay.newMes(id, 1);
        this.$refs.maintenanceItemDisplay.newMes(id, 1);
        this.$refs.inspectionItemDisplay.newMes(id, 1);
        this.$refs.electronDocumentDisplay.newMes(id, 1);
        this.$refs.partInfoDisplay.newMes(id, 1);
        this.$refs.positionDisplay.newMes(id);
        this.search();
      })
    },
    async getEquipmentTypeList(param) {
      let childArr = [];
      await file.getEquipmentTypeList(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          childArr = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      return childArr
    },
    async getEquipmentInfoList(pid) {
      let childArr = [];
      let mes = {
        pid: pid,
        state: 1
      };
      await organizationTabJs.getChildren(mes).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          childArr = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      return childArr
    },
    async getEquipmentAreaInfoList(param) {
      let childArr = [];
      let mes = {};
      if (param) {
        mes = {
          areaId: param
        }
      } else {
        mes = {
          type: '2',
          areaId: param
        }
      }
      await file.getEquipmentInfoList(mes).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          childArr = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      return childArr
    },
    selectCard(id) {
      file1.selectCard(id).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.cardData = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    searchPage(param) {
      var dataParam = this.searchDataList;
      var newParam = Object.assign(param, dataParam);
    },
    search() {
      let param = {
        pageNum: 1,
        pageSize: this.pageSize,
      }
      this.$refs.checkItemDisplay.searchPage(param);
      this.$refs.maintenanceItemDisplay.searchPage(param);
      this.$refs.inspectionItemDisplay.searchPage(param);
      this.$refs.electronDocumentDisplay.searchPage(param);
      this.$refs.partInfoDisplay.searchPage(param);
      this.$refs.positionDisplay.searchPage(param);
    },
    getEquipmentParameter(param) {
      file1.getEquipmentParameter(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.parameterData = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    changeTime(value) {
      var arr = value;
      if (arr == null || arr == "") {
        return "-";
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].toString().length == 1) {
            arr[i] = "0" + arr[i];
          }
        }
        if (arr.length == 5) {
          var getFormatTime = arr[0] + "-" + arr[1] + "-" + arr[2] + "\t" + arr[3] + ":" + arr[4] + ":" + "00";
        } else {
          var getFormatTime = arr[0] + "-" + arr[1] + "-" + arr[2] + "\t" + arr[3] + ":" + arr[4] + ":" + arr[5];
        }
        return getFormatTime;
      }
    }
  },
  created() {
    //this.getEquipmentTypeList(0,1)
  }
}
</script>

<style>
.statusSpan {
  margin-right: 10px;
}

.el-tabs .el-tabs__content {
  /* overflow: scroll; */
  overflow-x: auto;
  overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/list/tree/warnTree.vue